import { Service } from "@front-apps/core/services/Service"
import welcome from "../assets/config/welcome.json"
import error from "../assets/config/error.json"
import clientInformations from "../assets/config/clientInformation.json"
import languageChoice from "../assets/config/languageChoice.json"
class LocalPageConfigService extends Service {
    private static instance: LocalPageConfigService

    constructor() {
        super()
        // set le nom du service
        this.name = "LocalPageConfigService"
    }

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): LocalPageConfigService {
        if (!this.instance) {
            this.instance = new LocalPageConfigService()
        }
        return this.instance
    }

    public async getPageConfig(page: string) {
        try {
            const pageConfigsMap = new Map()
            pageConfigsMap.set("languageChoice", languageChoice)
            pageConfigsMap.set("welcome", welcome)
            pageConfigsMap.set("clientInformations", clientInformations)
            pageConfigsMap.set("error", error)

            return pageConfigsMap.get(page)
        } catch (error) {
            console.error(error)
            throw error
        }
    }
}

export default LocalPageConfigService
